import axios from 'axios';
import type {
  EnhancedAppointment,
  IAppointmentConfig,
  JsonObject,
} from '@bb/domain/dist/types';
import type { ExternalListing } from 'contexts';
import type {
  OfferDetailsType,
  PermissionsType,
} from 'api/AppExternalController';
import type { FeedbackTemplate } from '@bb/domain/dist/types/Feedback';
import type { User } from '@bb/users';
import type { Org } from '@bb/automaton';
import type { ListingDoc } from '@bb/domain/dist/schemas';
import type { TourDetailsDTO } from '../../../api/types/MyBusinessTypes';

export type GetShowingDataListingDTO = JsonObject<
  | (Omit<ListingDoc, 'reps' | 'org'> & { reps: User[]; org: Org })
  | ExternalListing
>;

export type GetShowingDataDTO = JsonObject<{
  appointment: EnhancedAppointment;
  listing: GetShowingDataListingDTO;
  listingAppointmentConfig: IAppointmentConfig;
  permissions: PermissionsType;
  offerDetails: OfferDetailsType;
  feedbackConfig: { id?: string; template: FeedbackTemplate[] };
  covidSignatureType?: 'template' | 'pdf';
  tourDetails?: TourDetailsDTO<GetShowingDataListingDTO>;
  lockboxPhotoURL?: string;
  userType: 'coop' | 'agent';
}>;

const getShowingData = async (
  appointmentId: string,
  isListingAgent?: boolean,
) => {
  const { data } = await axios.get<GetShowingDataDTO>(
    `/my_business/showing/${appointmentId}?isListingAgent=${Boolean(
      isListingAgent,
    )}`,
  );
  return data;
};

export default getShowingData;
